import React, { useState, useEffect } from 'react';
import '../styles/Dashboard.css';

function NotificationModal({ isOpen, onClose, onSave, currentUser }) {
  const [formData, setFormData] = useState({
    notificationPreferences: {
      email: true,
      days: [30, 14, 7]
    }
  });

  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (currentUser) {
      setFormData({
        notificationPreferences: currentUser.notificationPreferences || {
          email: true,
          days: [30, 14, 7]
        }
      });
    }
  }, [currentUser]);

  const handleDayToggle = (day) => {
    setFormData(prev => {
      const days = prev.notificationPreferences.days;
      const newDays = days.includes(day)
        ? days.filter(d => d !== day)
        : [...days, day].sort((a, b) => b - a);
      
      return {
        ...prev,
        notificationPreferences: {
          ...prev.notificationPreferences,
          days: newDays
        }
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await onSave({
        name: currentUser.name,
        notificationPreferences: formData.notificationPreferences
      });
      onClose();
    } catch (error) {
      alert('Failed to save notification preferences');
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '540px' }}>
        <div className="modal-header">
          <h2 style={{ fontSize: '24px', fontWeight: '700', color: 'var(--ink)', margin: 0 }}>
            Notification Preferences
          </h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body" style={{ paddingTop: '24px' }}>
            <div className="form-group">
              <label className="form-label" style={{ marginBottom: '8px', display: 'block' }}>
                Email Reminders
              </label>
              <small className="form-helper" style={{ marginBottom: '12px', display: 'block' }}>
                Get reminded before your certificates expire
              </small>
              
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(3, 1fr)', 
                gap: '8px'
              }}>
                {[30, 14, 7, 3, 1].map(day => (
                  <label 
                    key={day}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      cursor: 'pointer',
                      padding: '10px 14px',
                      border: '2px solid',
                      borderRadius: '8px',
                      backgroundColor: formData.notificationPreferences.days.includes(day) ? '#eff6ff' : 'white',
                      borderColor: formData.notificationPreferences.days.includes(day) ? '#1e3a8a' : '#e5e7eb',
                      transition: 'all 0.2s',
                      fontWeight: 500,
                      fontSize: '14px'
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={formData.notificationPreferences.days.includes(day)}
                      onChange={() => handleDayToggle(day)}
                      style={{ margin: 0, width: '16px', height: '16px', cursor: 'pointer', accentColor: 'var(--primary)' }}
                    />
                    <span>
                      {day} day{day !== 1 ? 's' : ''}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            <div style={{ 
              background: '#f0f9ff', 
              border: '1px solid #bfdbfe', 
              borderRadius: '8px', 
              padding: '14px 16px',
              marginTop: '24px',
              display: 'flex',
              gap: '10px',
              alignItems: 'flex-start'
            }}>
              <span style={{ fontSize: '18px' }}>💡</span>
              <p style={{ margin: 0, fontSize: '13px', color: '#1e3a8a', lineHeight: '1.5' }}>
                <strong>Tip:</strong> We recommend enabling reminders at 30, 14, and 7 days before expiry
              </p>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose} disabled={saving}>
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Saving...' : 'Save Preferences'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default NotificationModal;
